module.exports = __webpack_public_path__ + "img/tkt_eossanguotkt.f5c057a.png";